import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import {Observable, pipe} from 'rxjs/Rx';
import { map } from 'rxjs/operators';
import { Login, SessionInfo, NewUser, upersonalInfo } from '../../models/User';
import { CookieService } from 'ngx-cookie-service';
import { APIConstants } from 'src/app/app.constants';
import { throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor(private httpClient: HttpClient,
  public  _cookie: CookieService) { }
  readonly url = APIConstants.BASE_URL;

  loginUser(newLogin: Login): Observable<any> {
    return this.httpClient.post<any>(this.url + '/user/login', newLogin, {observe: 'response'});
  }
  
  otpLoginUser(otpLoginRM: {otpId:string,otp:string,phoneNumber:string}){
      return this.httpClient.post<any>(this.url+"/user/otp-login",otpLoginRM,{observe:'response'});
  }

  checkUser(number: string): Observable<any> {
    const params1 = new HttpParams().set('phoneNumber', number);
    return this.httpClient.get<any>(this.url + '/user/is-exists', {params: params1});
  }
  userCreate(user: NewUser): Observable<any> {
    const headers = new HttpHeaders({
        'Content-type': 'application/json'
      });
    const options = {headers};

    return this.httpClient.post<any>(this.url + '/user', user, options);
  }

  get(session: SessionInfo): Observable<any> {
    if (!session || !session.Authorization || !session.userId) {
      console.error("Session info is missing!");
      return throwError(() => new Error("Invalid session info"));
    }

    const headers = new HttpHeaders({
      Authorization: session.Authorization
    });

    const options = { headers };

    return this.httpClient.get(`${this.url}/user/self/${session.userId}`, options);
  }

  

 getRefer(session: SessionInfo): Observable<any> {
  const headers = new HttpHeaders({
    Authorization: session.Authorization
  });
  const options = {headers};

  return this.httpClient.get(this.url + '/referral?userId=' + session.userId, options);
 }

 update(personal: upersonalInfo, Authorization: string): Observable<any> {
  const headers = new HttpHeaders({
    'Content-type': 'application/json',
    Authorization});
  const options = { headers };

  return this.httpClient.put(this.url + '/user', personal, options);

 }
 ResetAccount(user: NewUser): Observable<any> {
  const headers = new HttpHeaders({
      'Content-type': 'application/json'
    });
  const options = {headers};

  return this.httpClient.put<any>(this.url + '/user/update-password', user, options);
}

  applyRefer(): Observable<any> {
    const headers = new HttpHeaders({
      'Content-type': 'application/json'
    });
    const options = {headers};
    const userId = this._cookie.get('UserID');
    const cartId = this._cookie.get('cartId');
    return this.httpClient.put<any>(this.url + '/cart/apply-onelap-coins?userId=' +
    userId +'&cartId='+ cartId, options);
  }

  removeRefer(): Observable<any> {
    const headers = new HttpHeaders({
      'Content-type': 'application/json'
    });
    const options = {headers};
    const cartId = this._cookie.get('cartId');
    return this.httpClient.put<any>(this.url + '/cart/apply-onelap-coins?&cartId='+ cartId, options);
  }
  getReferred(session: SessionInfo): Observable<any> {
    const headers = new HttpHeaders({
      Authorization: session.Authorization
    });
    const options = {headers};

    return this.httpClient.get(this.url + '/referral/referredCoins?userId=' + session.userId, options);
   }



  }
